import styled from 'styled-components'

const InformacjeUszczegolawiajaceStyle = styled.div`
  .subsection {
    width: 100%;
    display: grid;
    padding: 0 12px;
  }

  .header {
    width: 100%;
    height: 36px;
    background: ${props => props.theme.black4onBlack4};
    padding: 12px 20px 10px;
    font-family: 'Ubuntu';
    font-size: 11px;
    color: ${props => props.theme.black38};
    margin: 12px 0;
  }

  .attachment-header {
    font-family: 'Ubuntu-Light';
    font-size: 24px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    color: ${props => props.theme.black87};

    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 12px 8px 12px;
  }

  .listLabel {
    width: 100%;
    padding-left: 24px;
  }

  .container {
    padding: 0 12px;
  }
`
export default InformacjeUszczegolawiajaceStyle
